import { render, staticRenderFns } from "./driversLogsDetail.vue?vue&type=template&id=547dba4c"
import script from "./driversLogsDetail.vue?vue&type=script&lang=js"
export * from "./driversLogsDetail.vue?vue&type=script&lang=js"
import style0 from "./driversLogsDetail.vue?vue&type=style&index=0&id=547dba4c&prod&itemscope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports